import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { TemplateModule } from 'src/app/template/template.module';

import { ApprobationsModule } from '../approbations/approbations.module';
import { ClassesModule } from '../classes/classes.module';
import { DiscountsModule } from '../discounts/discounts.module';
import { EditionsModule } from '../editions/editions.module';
import { KnownsModule } from '../knowns/knowns.module';
import { StudentsModule } from '../students/students.module';

import { EnrollmentEditStepCampusComponent } from './components/enrollment-edit/components/enrollment-edit-step-campus/enrollment-edit-step-campus.component';
import { EnrollmentEditStepCoursesComponent } from './components/enrollment-edit/components/enrollment-edit-step-courses/enrollment-edit-step-courses.component';
import { EnrollmentEditStepDiscountsComponent } from './components/enrollment-edit/components/enrollment-edit-step-discounts/enrollment-edit-step-discounts.component';
import { EnrollmentEditStepPrivacyPolicyComponent } from './components/enrollment-edit/components/enrollment-edit-step-privacy-policy/enrollment-edit-step-privacy-policy.component';
import { EnrollmentEditStepApprobationsComponent } from './components/enrollment-edit/components/enrollment-edit-step-approbations/enrollment-edit-step-approbations.component';
import { EnrollmentEditStepSummaryComponent } from './components/enrollment-edit/components/enrollment-edit-step-summary/enrollment-edit-step-summary.component';
import { EnrollmentEditStepConfirmationComponent } from './components/enrollment-edit/components/enrollment-edit-step-confirmation/enrollment-edit-step-confirmation.component';

import { EnrollmentDetailComponent } from './components/enrollment-detail/enrollment-detail.component';
import { EnrollmentEditComponent } from './components/enrollment-edit/enrollment-edit.component';
import { EnrollmentPaymentRedsysComponent } from './components/enrollment-payment-redsys/enrollment-payment-redsys.component';
import { EnrollmentSummaryCardComponent } from './components/enrollment-summary-card/enrollment-summary-card.component';

import { EnrollmentInfoComponent } from './pages/enrollment-info/enrollment-info.component';
import { EnrollmentNewComponent } from './pages/enrollment-new/enrollment-new.component';
import { EnrollmentPaymentResultComponent } from './pages/enrollment-payment-result/enrollment-payment-result.component';
import { EnrollmentsListComponent } from './pages/enrollments-list/enrollments-list.component';

import { EnrollmentPaymentInfoService } from './services/enrollment-payment-info.service';
import { EnrollmentPaymentRedsysService } from './services/enrollment-payment-redsys.service';
import { EnrollmentService } from './services/enrollment.service';

@NgModule({

    declarations: [

        EnrollmentEditStepCampusComponent,
        EnrollmentEditStepCoursesComponent,
        EnrollmentEditStepDiscountsComponent,
        EnrollmentEditStepPrivacyPolicyComponent,
        EnrollmentEditStepApprobationsComponent,
        EnrollmentEditStepSummaryComponent,
        EnrollmentEditStepConfirmationComponent,

        EnrollmentDetailComponent,
        EnrollmentEditComponent,
        EnrollmentPaymentRedsysComponent,
        EnrollmentSummaryCardComponent,

        EnrollmentInfoComponent,
        EnrollmentNewComponent,
        EnrollmentPaymentResultComponent,
        EnrollmentsListComponent,
        EnrollmentSummaryCardComponent

    ],

    imports: [

        CommonModule,
        SharedModule,
        TemplateModule,

        ApprobationsModule,
        ClassesModule,
        DiscountsModule,
        EditionsModule,
        KnownsModule,
        StudentsModule

    ],

    exports: [

        EnrollmentsListComponent,
        EnrollmentNewComponent,
        EnrollmentInfoComponent

    ],

    providers: [

        EnrollmentPaymentInfoService,
        EnrollmentPaymentRedsysService,
        EnrollmentService

    ]

})
export class EnrollmentsModule { }
